import {Navbar} from "../components/Navbar";
import React from "react";
import {BannerPage} from "../components/BannerPage";
import {Onglets} from "../components/Onglets";

export const ImpactStudy = () => {
    return (

        <div>

           <BannerPage title={"Étude d'impacte & autres réglementations"} image={"/assets/images/gallery/fleurs.jpg"}/>
            <Navbar />
            {/*// <!-- hr -->*/}
            {/*<hr className="line-vr-section"/>*/}
            {/*// <!-- Project -->*/}
            {/* <!-- Slider Services Box --> */}
            <Onglets />
            <div className="section-padding">
                <div className="container">
                    <h2 className="title-color">Étude d'impacte & autres réglementations</h2>
                    <h4>NATURAE porte les études et dossiers d’ordre réglementaire en lien avec le
                        code de l’environnement, tels :</h4>
                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="col-md-4">
                            <ul>
                                <li><p>• Evaluation environnementale volet Faune Flore (étude d’impact)</p></li>
                                <li><p>• Dossier cas par cas, autorisation</p></li>
                                <li><p>• Dérogation espèces protégées</p></li>
                                <li><p>• Dossier Loi sur l’eau</p></li>
                                <li><p>• Diagnostic Zones humides (relevés floristiques, pédologiques)</p></li>
                                <li><p>• Elaboration des mesures Eviter Réduire Compenser (ERC)</p></li>
                                <li><p>• Restauration des milieux</p></li>
                                <li><p>• Plan de gestion des espaces naturels</p></li>
                            </ul>
                        </div>
                        <div className="col-md-8">
                            <div className="row align-items-stretch savoye-photos">
                                <div className="col-md-12 items mb-30">
                                    <a href="/assets/images/gallery/vue-ensemble.PNG" className="d-block savoye-photo-item"
                                       data-caption="Project page" data-fancybox="gallery"> <img src="/assets/images/gallery/vue-ensemble.PNG"
                                                                                                 alt=""
                                                                                                 className="img-fluid"/>
                                    </a>
                                </div>
                                {/*<div className="col-md-6 items mb-30">*/}
                                {/*    <a href="img/services/1.jpg" className="d-block savoye-photo-item" data-caption="Project page" data-fancybox="gallery"> <img src="img/services/1.jpg" alt="" className="img-fluid"/> </a>*/}
                                {/*</div>*/}
                                {/*<div className="col-md-6 items mb-30">*/}
                                {/*    <a href="img/services/2.jpg" className="d-block savoye-photo-item" data-caption="Project page" data-fancybox="gallery"> <img src="img/services/2.jpg" alt="" className="img-fluid"/> </a>*/}
                                {/*</div>*/}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
